import React from 'react';
import "./teamOwnerBox.scss";

const TeamOwnerBox = (props) => {
  return (
    <>
      <div className="teamownerBoxWrapper">
        <div className='ownerBoxBg'>
          <img className='teamimg1' src={props.teamImage} alt="" />

        </div>
        <h5 className='teamMembername'>{props.teamname}</h5>
        <p className='memberjob'>{props.teamjob}</p>
      </div>

    </>
  )
}

export default TeamOwnerBox;